import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';

function gradeLabel(s){ return s>=90?'A+':s>=80?'A':s>=70?'B+':s>=60?'B':s>=50?'C':'D'; }
function gradeColor(s){ return s>=80?'#15803d':s>=60?'#854d0e':'#dc2626'; }
function gradeBg(s){ return s>=80?'#dcfce7':s>=60?'#fef9c3':'#fef2f2'; }

const catTargets={'No Internet Connection':4,'Slow Speed':2,'Router/ONT Issue':8,'Cable Cut':24,'Frequent Disconnection':6,'Billing Issue':2,'New Connection':48,'Others':24};

export default function KRAReport() {
  const { tenant, user } = useAuth();
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedTech, setSelectedTech] = useState('all');
  const [selectedSubDist, setSelectedSubDist] = useState('all');
  const [dateMode, setDateMode] = useState('monthly');
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth()+1);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [technicians, setTechnicians] = useState([]);
  const [subDists, setSubDists] = useState([]);
  const [expandedTech, setExpandedTech] = useState(null);
  const primaryColor = tenant?.branding?.primary_color || '#1B6B3A';

  useEffect(()=>{
    const token = localStorage.getItem('token');
    fetch('/api/users/technicians',{headers:{Authorization:'Bearer '+token}})
      .then(r=>r.json()).then(d=>{
        const techs=(d.technicians||[]).filter(t=>['subdist_tech_own','subdist_tech_isp','isp_technician','dist_l1','dist_l2','dist_l3'].includes(t.role));
        setTechnicians(techs);
        const sds=[...new Set(techs.map(t=>t.sub_dist_code).filter(Boolean))].sort();
        setSubDists(sds);
      }).catch(()=>{});
  },[]);

  const loadReport = async () => {
    setLoading(true);
    setExpandedTech(null);
    try {
      const token = localStorage.getItem('token');
      const params = new URLSearchParams();
      params.set('month', selectedMonth);
      params.set('year', selectedYear);
      if(selectedTech!=='all') params.set('technician_id', selectedTech);
      if(selectedSubDist!=='all') params.set('sub_dist', selectedSubDist);
      const r = await fetch('/api/reports/tech-work-report?'+params.toString(),{headers:{Authorization:'Bearer '+token}});
      const d = await r.json();
      setReports(d.reports||[]);
    } catch(e){ setReports([]); }
    setLoading(false);
  };

  const printReport = () => {
    const rows = reports.map((r,i)=>`
      <tr style="background:${i%2?'#f8fafc':'white'}">
        <td>${i+1}</td><td>${r.technician.name}</td><td>${r.technician.role}</td>
        <td>${r.technician.sub_dist_code||'-'}</td>
        <td style="text-align:center">${r.stats.total}</td>
        <td style="text-align:center">${r.stats.resolved}</td>
        <td style="text-align:center">${r.stats.escalated}</td>
        <td style="text-align:center">${r.stats.avg_resolution_hours}h</td>
        <td style="text-align:center">${r.stats.resolution_rate}%</td>
        <td style="text-align:center;font-weight:800;color:${gradeColor(r.stats.kra_score||0)}">${r.stats.kra_score||0}% — ${gradeLabel(r.stats.kra_score||0)}</td>
      </tr>`).join('');
    const w = window.open('','_blank');
    w.document.write(`<!DOCTYPE html><html><head><title>KRA Report</title>
      <style>body{font-family:Arial,sans-serif;padding:20px}h1{font-size:18px;margin:0 0 4px}
      p{font-size:12px;color:#64748b;margin:0 0 16px}
      table{width:100%;border-collapse:collapse;font-size:12px}
      th,td{padding:8px 10px;border:1px solid #e2e8f0;text-align:left}
      th{background:#1e293b;color:white;font-weight:600}</style></head>
      <body><h1>📊 Tech KRA Performance Report</h1>
      <p>${['January','February','March','April','May','June','July','August','September','October','November','December'][selectedMonth-1]} ${selectedYear}</p>
      <table><thead><tr>
        <th>#</th><th>Name</th><th>Role</th><th>Sub-Dist</th>
        <th>Total</th><th>Resolved</th><th>Escalated</th><th>Avg Time</th><th>Rate</th><th>KRA Score</th>
      </tr></thead><tbody>${rows}</tbody></table></body></html>`);
    w.document.close(); w.print();
  };

  return (
    <div style={{padding:'24px',maxWidth:'1400px',margin:'0 auto'}}>
      {/* Header */}
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'20px'}}>
        <div>
          <h2 style={{margin:'0 0 4px',fontSize:'22px',fontWeight:'800',color:'#0f172a'}}>📊 KRA Performance Report</h2>
          <p style={{margin:0,fontSize:'13px',color:'#64748b'}}>Key Result Area scoring for each technician</p>
        </div>
        {reports.length>0 && (
          <button onClick={printReport} style={{background:'#1e293b',color:'white',border:'none',borderRadius:'8px',padding:'9px 18px',cursor:'pointer',fontSize:'13px',fontWeight:'600'}}>🖨️ Print Report</button>
        )}
      </div>

      {/* Filters */}
      <div style={{background:'white',borderRadius:'10px',padding:'16px',boxShadow:'0 2px 10px rgba(0,0,0,0.06)',marginBottom:'20px'}}>
        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr 1fr auto',gap:'12px',alignItems:'flex-end'}}>
          <div>
            <label style={{display:'block',marginBottom:'5px',fontSize:'12px',fontWeight:'600',color:'#64748b'}}>Month</label>
            <select value={selectedMonth} onChange={e=>setSelectedMonth(parseInt(e.target.value))} style={{width:'100%',padding:'8px 12px',border:'1px solid #ddd',borderRadius:'6px',fontSize:'13px'}}>
              {['January','February','March','April','May','June','July','August','September','October','November','December'].map((m,i)=>(
                <option key={i+1} value={i+1}>{m}</option>
              ))}
            </select>
          </div>
          <div>
            <label style={{display:'block',marginBottom:'5px',fontSize:'12px',fontWeight:'600',color:'#64748b'}}>Year</label>
            <select value={selectedYear} onChange={e=>setSelectedYear(parseInt(e.target.value))} style={{width:'100%',padding:'8px 12px',border:'1px solid #ddd',borderRadius:'6px',fontSize:'13px'}}>
              {[2024,2025,2026,2027].map(y=><option key={y} value={y}>{y}</option>)}
            </select>
          </div>
          <div>
            <label style={{display:'block',marginBottom:'5px',fontSize:'12px',fontWeight:'600',color:'#64748b'}}>Sub-District</label>
            <select value={selectedSubDist} onChange={e=>setSelectedSubDist(e.target.value)} style={{width:'100%',padding:'8px 12px',border:'1px solid #ddd',borderRadius:'6px',fontSize:'13px'}}>
              <option value="all">All Sub-Dists</option>
              {subDists.map(s=><option key={s} value={s}>{s}</option>)}
            </select>
          </div>
          <div>
            <label style={{display:'block',marginBottom:'5px',fontSize:'12px',fontWeight:'600',color:'#64748b'}}>Technician</label>
            <select value={selectedTech} onChange={e=>setSelectedTech(e.target.value)} style={{width:'100%',padding:'8px 12px',border:'1px solid #ddd',borderRadius:'6px',fontSize:'13px'}}>
              <option value="all">All Technicians</option>
              {technicians.filter(t=>selectedSubDist==='all'||t.sub_dist_code===selectedSubDist).map(t=>(
                <option key={t._id} value={t._id}>{t.name}</option>
              ))}
            </select>
          </div>
          <button onClick={loadReport} disabled={loading} style={{padding:'9px 20px',background:loading?'#ccc':primaryColor,color:'white',border:'none',borderRadius:'6px',cursor:loading?'not-allowed':'pointer',fontWeight:'700',fontSize:'13px',whiteSpace:'nowrap'}}>
            {loading?'Loading...':'📊 Generate'}
          </button>
        </div>
      </div>

      {/* Summary Table */}
      {reports.length>0 && (
        <div style={{background:'white',borderRadius:'10px',boxShadow:'0 2px 10px rgba(0,0,0,0.06)',marginBottom:'20px',overflow:'hidden'}}>
          <table style={{width:'100%',borderCollapse:'collapse',fontSize:'13px'}}>
            <thead>
              <tr style={{background:'#1e293b'}}>
                {['#','Technician','Sub-Dist','Total','Resolved','Escalated','Avg Time','Rate','KRA Score',''].map(h=>(
                  <th key={h} style={{padding:'11px 12px',textAlign:'left',color:'white',fontWeight:'600',fontSize:'11px'}}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {reports.map((report,i)=>(
                <React.Fragment key={report.technician.id}>
                  <tr style={{borderTop:'1px solid #f1f5f9',background:expandedTech===report.technician.id?'#eff6ff':i%2===0?'white':'#fafafa'}}>
                    <td style={{padding:'10px 12px',color:'#94a3b8',fontSize:'11px'}}>{i+1}</td>
                    <td style={{padding:'10px 12px'}}>
                      <div style={{fontWeight:'700',color:'#1e293b'}}>{report.technician.name}</div>
                      <div style={{fontSize:'11px',color:'#64748b'}}>{report.technician.phone}</div>
                    </td>
                    <td style={{padding:'10px 12px',fontSize:'12px',color:'#64748b'}}>{report.technician.sub_dist_code||'-'}</td>
                    <td style={{padding:'10px 12px',fontWeight:'700',color:'#2563eb'}}>{report.stats.total}</td>
                    <td style={{padding:'10px 12px',fontWeight:'600',color:'#15803d'}}>{report.stats.resolved}</td>
                    <td style={{padding:'10px 12px',color:'#dc2626'}}>{report.stats.escalated}</td>
                    <td style={{padding:'10px 12px',color:'#7c3aed',fontWeight:'600'}}>{report.stats.avg_resolution_hours}h</td>
                    <td style={{padding:'10px 12px'}}>
                      <span style={{background:report.stats.resolution_rate>=80?'#dcfce7':'#fef9c3',color:report.stats.resolution_rate>=80?'#15803d':'#854d0e',padding:'2px 8px',borderRadius:'10px',fontWeight:'700',fontSize:'11px'}}>{report.stats.resolution_rate}%</span>
                    </td>
                    <td style={{padding:'10px 12px'}}>
                      <div style={{display:'flex',alignItems:'center',gap:'8px'}}>
                        <span style={{fontSize:'18px',fontWeight:'900',color:gradeColor(report.stats.kra_score||0)}}>{report.stats.kra_score||0}%</span>
                        <span style={{background:gradeBg(report.stats.kra_score||0),color:gradeColor(report.stats.kra_score||0),padding:'2px 8px',borderRadius:'10px',fontWeight:'700',fontSize:'11px'}}>{gradeLabel(report.stats.kra_score||0)}</span>
                      </div>
                    </td>
                    <td style={{padding:'10px 12px'}}>
                      <button onClick={()=>setExpandedTech(expandedTech===report.technician.id?null:report.technician.id)}
                        style={{padding:'4px 12px',background:expandedTech===report.technician.id?'#1e293b':'#2563eb',color:'white',border:'none',borderRadius:'6px',cursor:'pointer',fontSize:'11px',fontWeight:'600'}}>
                        {expandedTech===report.technician.id?'▲ Hide':'👁 Details'}
                      </button>
                    </td>
                  </tr>
                  {expandedTech===report.technician.id && (
                    <tr>
                      <td colSpan={10} style={{padding:'0',background:'#f8fafc',borderBottom:'2px solid #2563eb'}}>
                        <div style={{padding:'20px'}}>
                          {/* Dark header */}
                          <div style={{background:'linear-gradient(135deg,#1e293b,#334155)',borderRadius:'12px',padding:'16px 20px',marginBottom:'16px',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                            <div>
                              <div style={{color:'#94a3b8',fontSize:'10px',fontWeight:'700',textTransform:'uppercase',letterSpacing:'1px',marginBottom:'4px'}}>KRA Performance Report</div>
                              <div style={{color:'white',fontSize:'16px',fontWeight:'700'}}>{report.technician.name}</div>
                              <div style={{color:'#94a3b8',fontSize:'12px',marginTop:'2px'}}>{report.stats.total} tickets • {report.stats.resolved} resolved • {report.stats.avg_resolution_hours}h avg • {report.technician.sub_dist_code}</div>
                            </div>
                            <div style={{textAlign:'center'}}>
                              <div style={{fontSize:'42px',fontWeight:'900',color:'white',lineHeight:1}}>{report.stats.kra_score||0}%</div>
                              <div style={{background:gradeBg(report.stats.kra_score||0),color:gradeColor(report.stats.kra_score||0),padding:'4px 16px',borderRadius:'20px',fontWeight:'800',fontSize:'14px',marginTop:'8px'}}>Grade: {gradeLabel(report.stats.kra_score||0)}</div>
                            </div>
                          </div>

                          {/* 4 KRA metrics */}
                          <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:'10px',marginBottom:'16px'}}>
                            {[
                              {label:'SLA Compliance',val:report.stats.kra_breakdown?.sla||0,weight:'40%',icon:'⏱️',desc:'Resolved before deadline'},
                              {label:'Resolution Speed',val:report.stats.kra_breakdown?.speed||0,weight:'30%',icon:'⚡',desc:'Actual vs expected time per category'},
                              {label:'No Escalation',val:report.stats.kra_breakdown?.no_escalation||0,weight:'20%',icon:'🎯',desc:'Closed without escalating'},
                              {label:'First Time Fix',val:report.stats.kra_breakdown?.first_time||0,weight:'10%',icon:'✅',desc:'Not reopened after resolution'},
                            ].map((m,i)=>(
                              <div key={i} style={{background:'white',borderRadius:'10px',padding:'12px 14px',border:'1px solid #e2e8f0'}}>
                                <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'6px'}}>
                                  <div style={{display:'flex',alignItems:'center',gap:'6px'}}>
                                    <span style={{fontSize:'14px'}}>{m.icon}</span>
                                    <span style={{fontSize:'11px',fontWeight:'700',color:'#334155'}}>{m.label}</span>
                                  </div>
                                  <span style={{fontSize:'9px',color:'#94a3b8'}}>wt:{m.weight}</span>
                                </div>
                                <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:'5px'}}>
                                  <span style={{fontSize:'20px',fontWeight:'900',color:gradeColor(m.val)}}>{m.val}%</span>
                                  <span style={{background:gradeBg(m.val),color:gradeColor(m.val),padding:'1px 8px',borderRadius:'10px',fontWeight:'700',fontSize:'10px'}}>{gradeLabel(m.val)}</span>
                                </div>
                                <div style={{background:'#e2e8f0',borderRadius:'4px',height:'6px',overflow:'hidden'}}>
                                  <div style={{width:m.val+'%',height:'100%',borderRadius:'4px',background:m.val>=80?'#16a34a':m.val>=60?'#d97706':'#dc2626'}}></div>
                                </div>
                                <div style={{fontSize:'9px',color:'#94a3b8',marginTop:'4px'}}>{m.desc}</div>
                              </div>
                            ))}
                          </div>

                          {/* Category breakdown */}
                          {(()=>{
                            const catMap={};
                            report.tickets.filter(t=>t.ticket_type!=='internal').forEach(t=>{
                              if(!t.category) return;
                              if(!catMap[t.category]) catMap[t.category]={count:0,totalHours:0,resolved:0};
                              catMap[t.category].count++;
                              if(t.status==='resolved'||t.status==='closed'){
                                catMap[t.category].resolved++;
                                const hrs=(new Date(t.updated)-new Date(t.created))/(1000*60*60);
                                catMap[t.category].totalHours+=hrs;
                              }
                            });
                            const cats=Object.entries(catMap);
                            if(cats.length===0) return null;
                            return (
                              <div style={{background:'white',borderRadius:'10px',padding:'14px',border:'1px solid #e2e8f0',marginBottom:'16px'}}>
                                <div style={{fontWeight:'700',fontSize:'12px',color:'#334155',marginBottom:'10px',textTransform:'uppercase',letterSpacing:'.5px'}}>📋 Performance by Ticket Category</div>
                                <table style={{width:'100%',borderCollapse:'collapse',fontSize:'12px'}}>
                                  <thead>
                                    <tr style={{background:'#f1f5f9'}}>
                                      {['Category','Tickets','Resolved','Avg Time','Target','Speed Score'].map(h=>(
                                        <th key={h} style={{padding:'7px 10px',textAlign:'left',color:'#64748b',fontWeight:'600',fontSize:'11px'}}>{h}</th>
                                      ))}
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {cats.map(([cat,d],i)=>{
                                      const target=catTargets[cat]||24;
                                      const avg=d.resolved>0?Math.round(d.totalHours/d.resolved*10)/10:0;
                                      const score=d.resolved>0?Math.min(100,Math.round((target/Math.max(avg,0.1))*100)):null;
                                      return (
                                        <tr key={i} style={{borderTop:'1px solid #f1f5f9',background:i%2===0?'white':'#fafafa'}}>
                                          <td style={{padding:'7px 10px',fontWeight:'600',color:'#334155'}}>{cat}</td>
                                          <td style={{padding:'7px 10px',textAlign:'center',fontWeight:'600'}}>{d.count}</td>
                                          <td style={{padding:'7px 10px',textAlign:'center',color:'#15803d',fontWeight:'600'}}>{d.resolved}</td>
                                          <td style={{padding:'7px 10px',textAlign:'center',color:'#7c3aed',fontWeight:'600'}}>{avg>0?avg+'h':'-'}</td>
                                          <td style={{padding:'7px 10px',textAlign:'center',color:'#64748b'}}>{target}h</td>
                                          <td style={{padding:'7px 10px',textAlign:'center'}}>
                                            {score!==null?<span style={{background:gradeBg(score),color:gradeColor(score),padding:'3px 10px',borderRadius:'10px',fontWeight:'700',fontSize:'11px'}}>{Math.min(score,100)}%</span>:'-'}
                                          </td>
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                </table>
                              </div>
                            );
                          })()}

                          {/* Ticket list */}
                          <div style={{background:'white',borderRadius:'10px',border:'1px solid #e2e8f0',overflow:'hidden'}}>
                            <div style={{padding:'10px 14px',borderBottom:'1px solid #f1f5f9',fontWeight:'700',fontSize:'12px',color:'#334155',textTransform:'uppercase',letterSpacing:'.5px'}}>🎫 Ticket Details ({report.tickets.length})</div>
                            <div style={{overflowX:'auto'}}>
                              <table style={{width:'100%',borderCollapse:'collapse',fontSize:'11px'}}>
                                <thead>
                                  <tr style={{background:'#f8fafc'}}>
                                    {['Ticket#','Customer','Category','Status','ISP Ticket','Created','Time Taken'].map(h=>(
                                      <th key={h} style={{padding:'7px 10px',textAlign:'left',color:'#64748b',fontWeight:'600'}}>{h}</th>
                                    ))}
                                  </tr>
                                </thead>
                                <tbody>
                                  {report.tickets.map((t,i)=>{
                                    const hrs = t.created&&t.updated?Math.round((new Date(t.updated)-new Date(t.created))/3600000*10)/10:null;
                                    const target = catTargets[t.category]||24;
                                    const onTime = hrs!==null&&(t.status==='resolved'||t.status==='closed')&&hrs<=target;
                                    return (
                                      <tr key={i} style={{borderTop:'1px solid #f1f5f9',background:i%2===0?'white':'#fafafa'}}>
                                        <td style={{padding:'6px 10px',fontWeight:'600',color:'#2563eb'}}>{t.ticket_number}</td>
                                        <td style={{padding:'6px 10px'}}>
                                          <div style={{fontWeight:'500'}}>{t.customer||'-'}</div>
                                          <div style={{fontSize:'10px',color:'#94a3b8'}}>{t.connection_id||t.phone||''}</div>
                                        </td>
                                        <td style={{padding:'6px 10px',color:'#334155'}}>{t.category||'-'}</td>
                                        <td style={{padding:'6px 10px'}}>
                                          <span style={{background:t.status==='resolved'||t.status==='closed'?'#dcfce7':t.status==='escalated'?'#fef2f2':'#fef9c3',color:t.status==='resolved'||t.status==='closed'?'#15803d':t.status==='escalated'?'#dc2626':'#854d0e',padding:'2px 7px',borderRadius:'8px',fontSize:'10px',fontWeight:'600'}}>{t.status}</span>
                                        </td>
                                        <td style={{padding:'6px 10px'}}>{t.isp_ticket_id?<span style={{background:'#eff6ff',color:'#1d4ed8',padding:'2px 7px',borderRadius:'8px',fontSize:'10px',fontWeight:'600'}}>{t.isp_ticket_id}</span>:'-'}</td>
                                        <td style={{padding:'6px 10px',color:'#64748b',fontSize:'10px'}}>{t.created?new Date(t.created).toLocaleDateString('en-IN',{day:'2-digit',month:'short'})+' '+new Date(t.created).toLocaleTimeString('en-IN',{hour:'2-digit',minute:'2-digit'}):'-'}</td>
                                        <td style={{padding:'6px 10px'}}>
                                          {hrs!==null&&(t.status==='resolved'||t.status==='closed')?(
                                            <span style={{color:onTime?'#15803d':'#dc2626',fontWeight:'600'}}>{hrs}h {onTime?'✅':'⚠️'}<span style={{fontSize:'9px',color:'#94a3b8',marginLeft:'4px'}}>/{target}h</span></span>
                                          ):'-'}
                                        </td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {!loading && reports.length===0 && (
        <div style={{textAlign:'center',padding:'60px 20px',background:'white',borderRadius:'10px',boxShadow:'0 2px 10px rgba(0,0,0,0.06)'}}>
          <div style={{fontSize:'48px',marginBottom:'12px'}}>📊</div>
          <div style={{fontWeight:'700',fontSize:'16px',color:'#1e293b',marginBottom:'6px'}}>No Report Generated</div>
          <div style={{color:'#64748b',fontSize:'13px'}}>Select a month and click Generate to view KRA performance</div>
        </div>
      )}
    </div>
  );
}
